var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.27441 9.98C2.94818 9.98 2.64335 9.875 2.42409 9.68C2.14599 9.435 2.01229 9.06499 2.06043 8.665L2.2583 7.045C2.29574 6.74 2.49361 6.335 2.72357 6.115L7.11424 1.77C8.21056 0.684995 9.35502 0.654995 10.5155 1.68C11.676 2.705 11.7081 3.775 10.6118 4.86L6.22113 9.205C5.99651 9.43 5.57937 9.64 5.25315 9.69L3.53111 9.965C3.4402 9.97 3.35998 9.98 3.27441 9.98ZM8.83093 1.675C8.41913 1.675 8.06082 1.915 7.69716 2.275L3.3065 6.625C3.19954 6.73 3.07654 6.98 3.05514 7.125L2.85727 8.745C2.83588 8.91 2.87866 9.045 2.97492 9.13C3.07119 9.215 3.21558 9.245 3.39206 9.22L5.1141 8.945C5.26919 8.92 5.52589 8.79 5.63285 8.685L10.0235 4.34C10.6867 3.68 10.9273 3.07 9.95934 2.22C9.53151 1.835 9.1625 1.675 8.83093 1.675Z",
    fill: "#888B94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58475 5.69514C9.57405 5.69514 9.55801 5.69514 9.54731 5.69514C7.87875 5.54014 6.53642 4.35514 6.27972 2.80514C6.24763 2.60014 6.39737 2.41014 6.61664 2.37514C6.8359 2.34514 7.03913 2.48514 7.07656 2.69014C7.27978 3.90014 8.32798 4.83014 9.63288 4.95014C9.85215 4.97014 10.0126 5.15514 9.99119 5.36014C9.96445 5.55014 9.78797 5.69514 9.58475 5.69514Z",
    fill: "#888B94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5421 11.5952H1.91574C1.69648 11.5952 1.51465 11.4252 1.51465 11.2202C1.51465 11.0152 1.69648 10.8452 1.91574 10.8452H11.5421C11.7613 10.8452 11.9431 11.0152 11.9431 11.2202C11.9431 11.4252 11.7613 11.5952 11.5421 11.5952Z",
    fill: "#888B94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit6);
export default __webpack_public_path__ + "static/media/edit-6.3178758cc1f12950ca39a2ad0ba9a359.svg";
export { ForwardRef as ReactComponent };